export enum PageSource {
    CART = 'cart',
    CHECKOUT = 'checkout',
    PDP = 'pdp',
    PLP = 'plp',
}
